<template>
  <div
    v-if="periodSelectionOption"
    class="tw-flex tw-items-center tw-pb-3 tw-gap-3"
  >
    <span class="tw-p-2 tw-bg-sf-slate-subtle-2 tw-rounded">
      <img
        v-tooltip.html.placementBottom="
          I18n.t(periodSelectionOption.tooltipKey)
        "
        :src="$imagesRequire(iconPath)"
        data-tooltip-size="sm"
      />
    </span>

    <span v-dompurify-html="title" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { SfTime } from '@app/adapters/time'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { periodSelectionOptions } from '../constants'
import { useInsightsRootStore } from '../store/insights-root'

const I18n = useI18n()
const rootStore = useInsightsRootStore()
const periodSelection = computed(() => rootStore.periodSelection)
const ledgerSelectDate = computed(() => rootStore.ledgerSelectDate)
const ledgerSelectLockType = computed(() => rootStore.ledgerSelectLockType)

const today = I18n.t(
  'companies_overview.period_selection_new.date_selection_placeholder_with_date',
  { date: SfTime(new Date()).format('DD/MM/YYYY') }
)
const periodSelectionOption = computed(() =>
  periodSelectionOptions.find((option) => option.key === periodSelection.value)
)

const iconPath = computed(
  () => `insights/${periodSelectionOption.value?.icon}-active.svg`
)

const lockType = computed(() => {
  // active_period/completed_period titles interpolate this; a URL (or old bookmark) can select
  // those periods without a lock type, leaving it null. Guard so the title never renders a
  // "[missing translation]" fragment for the null key.
  if (!ledgerSelectLockType.value) return ''

  return I18n.t(
    `companies_overview.period_selection_new.${periodSelection.value}_options.${ledgerSelectLockType.value}`
  ).toLowerCase()
})

const title = computed(() => {
  if (!periodSelectionOption.value) {
    return ''
  }

  return I18n.t(periodSelectionOption.value.titleKey, {
    date: ledgerSelectDate.value || today,
    lockType: lockType.value,
  })
})
</script>
<style scoped lang="scss">
:deep(.dropdown-trigger) {
  font-weight: bold;
}
</style>
